import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import finvuLogo from '../../assets/finvuFooterLogo.svg'

const VoiceJourneyFooter = ({ customDetails }) => {
    const theme = useTheme();
    const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '1rem',
                width: '100%',
                backgroundColor: '#fff',
            }}
        >
            <LockIcon
                sx={{
                    fontSize: mobileScreen ? '16px' : '20px',
                    color: theme.palette.text.secondary,
                }}
            />
            <Typography
                sx={{
                    fontSize: mobileScreen ? '12px' : '14px',
                    color: theme.palette.text.secondary,
                    whiteSpace: 'nowrap',
                    fontFamily: customDetails?.fontFamily,
                }}
            >
                Secured data sharing by RBI-Regulated AA
            </Typography>
            <Box
                component="img"
                src={finvuLogo}
                alt="Finvu"
                sx={{
                    height: mobileScreen ? '20px' : '24px',
                    width: 'auto',
                    objectFit: 'contain',
                }}
            />
        </Box>
    );
};

export default VoiceJourneyFooter;
